import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_central-desk/artifacts/087f6e7f7b1c5a04_assietica_logo_v2.png";

export const LEGACY_LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/4747fc23-0211-4673-a98f-4dc60c01ee96/images/668e06c89cee47519b4b8a5fb3c69172b4788b79c91ad1066a9f6cbe8ce1c78b.png";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
